<template>
  <div>
      <h3>Authenticating....</h3></div>
</template>
<script>
import { mapState } from "vuex";
import store from '@/store/index';
import auth from '@/data/auth';

export default {
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  mounted() {
    if(this.isAuthenticated) {
      this.$router.push('/')
    } else {
      var code = this.$route.query.code;
      var redirect_uri = window.location.protocol + "//" + window.location.host + "/tokenize";
      var verification = this.$route.query.state

      if (verification === null || verification !== store.state.auth.verification) {
          this.$router.push({
              name: 'error',
              params: {
                  message: 'The verification state in the authentication response did not match our original request'
              }
          })
      return
      }
      auth.setToken(code, redirect_uri);
    }
  }
};
</script>